/**
 * This is added as separate file to use the same for checkout and bag
 */
export default async function fireExperimentTag() {
  // Import Experimentation SDK and fireAdobeTags
  const { default: ExperimentationTags } = await import(/* webpackChunkName: "experimentation-tags", webpackPreload: true */
    '@common-vue/util/src/modules/experimentation/ExperimentationTags'
  );
  ExperimentationTags.fireAdobeTags();
}
